const MatchingSupplierCountSource = {
  PREVIEW: 'preview',
  MATCHES: 'matches',
  FALLBACK: 'fallback',
};

export default MatchingSupplierCountSource;
